export default {
  'nav.home': 'Ana Sayfa',
  'nav.services': 'Hizmetler',
  'nav.about': 'Hakkımızda',
  'nav.booking': 'Randevu Al',
  'nav.call': 'Hemen Ara',
  'nav.whatsapp': 'WhatsApp',

  'hero.badge': 'Van ve Çevre İlçeler · 7/24 Hizmet',
  'hero.scroll': 'Kaydır',
  'hero.slide1.title': 'Van\'ın Güvenilir Tesisatçısı',
  'hero.slide1.sub': 'Güler yüzlü personelimizle güvenle iş yapılır. Kalitenin tek adresi.',
  'hero.slide2.title': 'Her Tesisat İşinde Yanınızdayız',
  'hero.slide2.sub': 'Sıhhi tesisattan doğalgaza, kombi bakımından kanal açmaya kadar.',
  'hero.slide3.title': 'Hızlı & Kalıcı Çözümler',
  'hero.slide3.sub': 'Zamanında, titiz ve garantili işçilik. Van ve çevre ilçelerde hizmetinizdeyiz.',
  'hero.stat1.value': '15+',
  'hero.stat1.label': 'Yıllık Deneyim',
  'hero.stat2.value': '3',
  'hero.stat2.label': 'Uzman Usta',
  'hero.stat3.value': '500+',
  'hero.stat3.label': 'Tamamlanan İş',
  'hero.stat4.value': '7/24',
  'hero.stat4.label': 'Destek',

  'services.badge': 'Profesyonel Tesisat Hizmetleri',
  'services.title': 'Öne Çıkan',
  'services.highlight': 'Hizmetlerimiz',
  'services.subtitle': 'Van ve çevre ilçelerde güvenilir, hızlı ve kalıcı tesisat çözümleri sunuyoruz.',
  'services.viewAll': 'Tüm Hizmetleri Gör',
  'services.detail': 'Detay',
  'services.callBtn': 'Hemen Ara',

  'svc.1.title': 'Sıhhi Tesisat',
  'svc.1.desc': 'Ev ve iş yerleri için komple su tesisatı, boru döşeme ve su kaçağı tespiti hizmetleri.',
  'svc.2.title': 'Tamirat & Tadilat İşleri',
  'svc.2.desc': 'Musluk, lavabo, klozet değişimi, banyo tadilatı ve su tesisatı yenileme işleri.',
  'svc.3.title': 'Kombi Bakımı & Petek Temizliği',
  'svc.3.desc': 'Kombi servisi, petek temizliği ve su deposu tamiratı ile ısıtma sisteminizi koruyun.',
  'svc.4.title': 'Doğalgaz İç Tesisat',
  'svc.4.desc': 'Boru montajı, bay/banyo tadilatı, gaz kaçağı tespiti ve güvenlik kontrolü.',
  'svc.5.title': 'Kanal Açma & Tıkanıklık Açma',
  'svc.5.desc': 'Profesyonel makinelerle lavabo, tuvalet ve ana hat tıkanıklıklarını hızla çözeriz.',
  'svc.6.title': 'Musluk & Armatür Tamiratı',
  'svc.6.desc': 'Musluk değişimi ve tamiri, batarya montajı, su basıncı ayarlama hizmetleri.',
  'svc.7.title': 'Arıza Tespiti & Cihaz Onarımı',
  'svc.7.desc': 'Su kaçağı, basınç düşüklüğü ve tesisat arızalarını özel cihazlarla tahribatsız tespit.',
  'svc.8.title': 'Kooperatif & Site İşleri',
  'svc.8.desc': 'Apartman ve site tesisat yönetimi, ortak alan bakımı ve arıza planlaması.',
  'svc.9.title': 'Yangın Sistemleri',
  'svc.9.desc': 'Sprinkler ve yangın tesisatı kurulumu, yangın güvenlik sistemleri bakımı.',

  'whyus.badge': 'Neden Bizi Tercih Etmelisiniz?',
  'whyus.title': 'Kalite ve Güven',
  'whyus.highlight': 'Bir Arada',
  'whyus.subtitle': 'Vanpolat Tesisat olarak yıllardır Van\'da binlerce müşteriye güvenilir hizmet sunuyoruz.',
  'feat.1.title': 'Garantili İşçilik',
  'feat.1.desc': 'Tüm tesisat işlerimiz garantili. Sorun çıkarsa ücretsiz müdahale.',
  'feat.2.title': 'Hızlı Müdahale',
  'feat.2.desc': 'Van içi aynı gün, ilçeler için de en kısa sürede hizmet.',
  'feat.3.title': 'Lisanslı & Sigortalı',
  'feat.3.desc': 'Tüm ustalarımız belgeli, işler sigortalı şekilde yapılır.',
  'feat.4.title': 'Uygun Fiyat',
  'feat.4.desc': 'Piyasaya uygun, şeffaf fiyatlandırma. Gizli ücret yok.',
  'feat.5.title': '7/24 Destek',
  'feat.5.desc': 'Acil arızalarda WhatsApp veya telefon ile 7/24 ulaşabilirsiniz.',
  'feat.6.title': 'Profesyonel Ekipman',
  'feat.6.desc': 'Arıza tespit cihazları ve modern ekipmanlarla hızlı ve tahribatsız çözüm.',

  'team.badge': 'Ekibimiz',
  'team.title': 'Uzman',
  'team.highlight': 'Ustalarımız',
  'team.subtitle': 'Deneyimli ve güler yüzlü ekibimiz her zaman yanınızda.',
  'team.more': 'Hakkımızda Daha Fazla',
  'team.role.1': 'Tesisat Ustası & Kurucu',
  'team.role.2': 'Tesisat Ustası',
  'team.role.3': 'Tesisat Ustası',
  'team.desc.1': '15 yılı aşkın tecrübesiyle sıhhi tesisat ve doğalgaz sistemlerinde uzman.',
  'team.desc.2': 'Kombi bakımı, petek temizliği ve tadilat işlerinde deneyimli usta.',
  'team.desc.3': 'Kanal açma, arıza tespiti ve doğalgaz tesisatı konularında uzman.',

  'cta.title': 'Tesisat Sorununuz mu Var?',
  'cta.subtitle': 'Hemen arayın, en kısa sürede yerinizde olalım. Acil arızalarda da 7/24 hizmetinizdeyiz.',

  'contact.badge': 'İletişim',
  'contact.title': 'Bizimle',
  'contact.highlight': 'İletişime Geçin',
  'contact.subtitle': 'Sorularınız için form doldurun ya da direkt arayın — en kısa sürede dönelim.',
  'contact.form.title': 'Mesaj Gönderin',
  'contact.form.name': 'Ad Soyad *',
  'contact.form.namePH': 'Adınız ve soyadınız',
  'contact.form.phone': 'Telefon *',
  'contact.form.phonePH': '05XX XXX XXXX',
  'contact.form.email': 'E-posta',
  'contact.form.emailPH': 'ornek@email.com',
  'contact.form.serviceType': 'Hizmet Türü',
  'contact.form.selectPH': 'Seçiniz',
  'contact.form.message': 'Mesajınız *',
  'contact.form.messagePH': 'Tesisat sorununuzu veya talebinizi kısaca açıklayın...',
  'contact.form.submit': 'Mesaj Gönder',
  'contact.form.sending': 'Gönderiliyor...',
  'contact.success.title': 'Mesajınız Alındı!',
  'contact.success.sub': 'En kısa sürede sizinle iletişime geçeceğiz.',
  'contact.success.back': 'Yeni Mesaj Gönder',
  'contact.loc.label': 'Konum',
  'contact.loc.value': 'Van ve Çevre İlçeler, Türkiye',
  'contact.hours.label': 'Çalışma Saatleri',
  'contact.hours.value': 'Her gün 07:00 – 22:00 (Acil: 7/24)',
  'contact.wa.label': 'WhatsApp',
  'contact.wa.value': '0507 607 4165',
  'contact.svc.0': 'Seçiniz',
  'contact.svc.1': 'Sıhhi Tesisat',
  'contact.svc.2': 'Tamirat & Tadilat',
  'contact.svc.3': 'Kombi Bakımı & Petek Temizliği',
  'contact.svc.4': 'Doğalgaz İç Tesisat',
  'contact.svc.5': 'Kanal Açma',
  'contact.svc.6': 'Musluk Tamiratı',
  'contact.svc.7': 'Arıza Tespiti',
  'contact.svc.8': 'Kooperatif & Apartman İşleri',
  'contact.svc.9': 'Yangın Sistemleri',
  'contact.svc.10': 'Diğer',

  'reviews.badge': 'Müşteri Yorumları',
  'reviews.title': 'Müşterilerimiz',
  'reviews.highlight': 'Ne Diyor?',
  'reviews.subtitle': 'Binlerce memnun müşterimizin deneyimleri bizi en iyi anlatır.',
  'reviews.stat.score': 'Ortalama Puan',
  'reviews.stat.clients': 'Memnun Müşteri',
  'reviews.stat.satisfaction': 'Memnuniyet',
  'reviews.cta': 'Siz de Memnun Müşterilerimiz Arasına Katılın!',
  'review.1.name': 'Ahmet K.',
  'review.1.text': 'Engin usta ve ekibi işlerini zamanında ve titizlikle yapıyor. Güler yüzlü ve güvenilir hizmet! Sıhhi tesisat işlerini kusursuz hallettiler.',
  'review.1.service': 'Sıhhi Tesisat',
  'review.2.name': 'Fatma Ş.',
  'review.2.text': 'Kombi bakımı ve petek temizliği yaptırdım, tüm işler kusursuz ve hızlı. Fiyatları da çok uygundu, kesinlikle tavsiye ederim.',
  'review.2.service': 'Kombi Bakımı',
  'review.3.name': 'Mehmet A.',
  'review.3.text': 'Su kaçağı tespiti hızlı ve sorunsuz yapıldı, kesinlikle tavsiye ederim. Tahribatsız cihazlarla bulup anında müdahale ettiler.',
  'review.3.service': 'Arıza Tespiti',
  'review.4.name': 'Zeynep T.',
  'review.4.text': 'Banyo tadilatımı tam istediğim gibi yaptılar. Doğalgaz bağlantısından kadar her şeyi hallettiler. Çok memnunum!',
  'review.4.service': 'Banyo Tadilatı',
  'review.5.name': 'İbrahim Y.',
  'review.5.text': 'Apartmanımızın tüm kanal tıkanıklığını makinelerle kısa sürede açtılar. Profesyonel ekip, işini bilen ustalar.',
  'review.5.service': 'Kanal Açma',

  'footer.desc': 'Güler yüzlü personelimizle güvenle iş yapılır. Kalitenin tek adresi. Van ve çevre ilçelerde profesyonel tesisat hizmetleri.',
  'footer.quickLinks': 'Hızlı Bağlantılar',
  'footer.servicesTitle': 'Hizmetler',
  'footer.teamTitle': 'Ustalarımız',
  'footer.contactTitle': 'İletişim & Konum',
  'footer.link.home': 'Ana Sayfa',
  'footer.link.services': 'Hizmetlerimiz',
  'footer.link.about': 'Hakkımızda',
  'footer.link.booking': 'Randevu Al',
  'footer.svc.1': 'Sıhhi Tesisat',
  'footer.svc.2': 'Doğalgaz İç Tesisat',
  'footer.svc.3': 'Kombi Bakımı',
  'footer.svc.4': 'Kanal Açma',
  'footer.svc.5': 'Yangın Sistemleri',
  'footer.location': 'Van Merkez ve Çevre İlçeler, Türkiye',
  'footer.hours': 'Her gün 07:00 – 22:00',
  'footer.call': 'Hemen Ara',
  'footer.wa': 'WhatsApp ile Yaz',
  'footer.copyright': '© 2026 Vanpolat Tesisat. Tüm hakları saklıdır.',
  'footer.area': 'Van ve çevre ilçelerde profesyonel tesisat hizmetleri',

  'sp.hero.badge': 'Profesyonel Tesisat Hizmetleri',
  'sp.hero.title': 'Hizmetlerimiz',
  'sp.hero.sub': 'Sıhhi tesisattan doğalgaza, kombi bakımından yangın sistemlerine kadar tüm tesisat ihtiyaçlarınızda Van\'ın güvenilir ekibi.',
  'sp.grid.title': 'Tüm',
  'sp.grid.highlight': 'Hizmetlerimiz',
  'sp.grid.subtitle': 'Her türlü tesisat sorununda deneyimli ustalarımız yanınızda.',
  'sp.process.title': 'Nasıl',
  'sp.process.highlight': 'Çalışıyoruz?',
  'sp.process.subtitle': 'Kolay 4 adımda sorununuzu çözüyoruz.',
  'sp.step.1.title': 'Bizi Arayın',
  'sp.step.1.desc': 'Telefon veya WhatsApp ile talebinizi bildirin.',
  'sp.step.2.title': 'Yerinde Keşif',
  'sp.step.2.desc': 'Ustamız adresinize gelir, durumu inceler.',
  'sp.step.3.title': 'Ücretsiz Teklif',
  'sp.step.3.desc': 'Şeffaf fiyatlandırma ile onayınıza sunulur.',
  'sp.step.4.title': 'İş Tamamlanır',
  'sp.step.4.desc': 'Garantili ve titiz işçilikle iş bitirilir.',

  'ap.hero.badge': 'Hakkımızda',
  'ap.hero.title': 'Vanpolat Tesisat Ailesi',
  'ap.hero.sub': 'Van\'da yıllardır aile işletmesi olarak hizmet veren, deneyimli ve dürüst tesisat ekibi.',
  'ap.story.badge': 'Hikayemiz',
  'ap.story.title': 'Van\'ın Güvenilir Tesisat Ailesi',
  'ap.story.p1': 'Vanpolat Tesisat, Van\'da 15 yılı aşkın süredir faaliyet gösteren bir aile şirketidir. Engin POLAT öncülüğünde kurulan firmamız, bugün kardeşleri Hamza ve Hayrullah ile birlikte hizmet vermektedir.',
  'ap.story.p2': 'Sıhhi tesisattan doğalgaz iç tesisatına, kombi bakımından profesyonel kanal açma hizmetlerine kadar geniş bir yelpazede kaliteli işçilik sunan ekibimiz, her projede müşteri memnuniyetini ön planda tutar.',
  'ap.story.motto': '"Güler yüzlü personellerimizle iş yapılır. Kalitenin tek adresi."',
  'ap.cert.1': 'Doğalgaz İç Tesisat Belgesi',
  'ap.cert.2': 'Sıhhi Tesisat Yetki Belgesi',
  'ap.cert.3': 'İş Güvenliği Sertifikası',
  'ap.cert.4': 'Kombi Servis Yetkisi',
  'ap.stat.1.value': '15+',
  'ap.stat.1.label': 'Yıllık Tecrübe',
  'ap.stat.2.value': '3',
  'ap.stat.2.label': 'Uzman Usta',
  'ap.stat.3.value': '500+',
  'ap.stat.3.label': 'Tamamlanan Proje',
  'ap.stat.4.value': '%100',
  'ap.stat.4.label': 'Müşteri Memnuniyeti',
  'ap.values.badge': 'Değerlerimiz',
  'ap.values.title': 'Bizi',
  'ap.values.highlight': 'Özel Yapan Değerler',
  'val.1.title': 'Güvenilirlik',
  'val.1.desc': 'Söylediğimizi yapıyoruz. Her iş garantili ve dürüst.',
  'val.2.title': 'Güler Yüzlü Hizmet',
  'val.2.desc': 'Müşterilerimizi her zaman sıcak bir ortamda karşılıyoruz.',
  'val.3.title': 'Kaliteli İşçilik',
  'val.3.desc': 'İşi ilk seferinde doğru ve kalıcı şekilde yapıyoruz.',
  'val.4.title': 'Zamanında Hizmet',
  'val.4.desc': 'Belirlenen saate uyuyoruz, müşteri vaktini değerli buluyoruz.',
  'ap.team.badge': 'Ekibimiz',
  'ap.team.title': 'Ustalarımızla',
  'ap.team.highlight': 'Tanışın',
  'ap.team.subtitle': 'Deneyimli, güler yüzlü ve işini seven Vanpolat ekibi.',
  'ap.cta.title': 'Bir Tesisat Sorunum Var, Şimdi Ne Yapayım?',
  'ap.cta.sub': 'Hemen arayın ya da WhatsApp\'tan yazın — güler yüzlü ekibimiz en kısa sürede yanınızda.',
  'ap.xp': 'Yıllık Deneyim',

  'lang.tr': 'Türkçe',
  'lang.en': 'English',
  'lang.ar': 'العربية',
};
